import BaseServiceHttp from '../baseService'
class Users extends BaseServiceHttp {
  constructor(id) {
    const resource = 'users'
    const relationship = {
      me: 'me'
    }
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new Users(id)
